/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MiniAppLicensingResponse
 */
export interface MiniAppLicensingResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MiniAppLicensingResponse
     */
    licensed: boolean;
    /**
     * Set only when a BI grace period alone licenses the miniapp
     * @type {Date}
     * @memberof MiniAppLicensingResponse
     */
    expires_on?: Date;
}

/**
 * Check if a given object implements the MiniAppLicensingResponse interface.
 */
export function instanceOfMiniAppLicensingResponse(value: object): value is MiniAppLicensingResponse {
    if (!('licensed' in value) || value['licensed'] === undefined) return false;
    return true;
}

export function MiniAppLicensingResponseFromJSON(json: any): MiniAppLicensingResponse {
    return MiniAppLicensingResponseFromJSONTyped(json, false);
}

export function MiniAppLicensingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiniAppLicensingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'licensed': json['licensed'],
        'expires_on': json['expires_on'] == null ? undefined : (new Date(json['expires_on'])),
    };
}

export function MiniAppLicensingResponseToJSON(json: any): MiniAppLicensingResponse {
    return MiniAppLicensingResponseToJSONTyped(json, false);
}

export function MiniAppLicensingResponseToJSONTyped(value?: MiniAppLicensingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'licensed': value['licensed'],
        'expires_on': value['expires_on'] == null ? undefined : ((value['expires_on']).toISOString().substring(0,10)),
    };
}

